import { PortableText } from '@portabletext/react'
import { ptComponents, updateMarksToBreak } from '../../../sanity/util'

const BlogDetailPortableTextSection = ({ value }) => {
  const content = updateMarksToBreak(value)

  return (
    <>
      <PortableText value={content} components={ptComponents} />
    </>
  )
}

export default BlogDetailPortableTextSection
